import { Contract, BigNumber } from 'ethers'

import { UserRoles } from 'src/constants'

import { EIntroducerAddressTypes, ECountry, User } from '../state/effector/users/user.types'

export type TTokenType = 'ERC1155' | 'ERC721'
export type WhiteListStatuses = 'PENDING' | 'ACCEPTED' | 'REJECTED'

export type CurrencyInfoProps = {
  tokenBalance: string
  symbol: string
  contract: Contract
}
export type CurrencyListProps = {
  symbol: string
  icon: string
  balance: string
}
export type PriceInfoProps = {
  price: BigNumber
  priceConverted: string
  nftCount: number
  nftPrice: BigNumber
}
export type AvailabilityInfoProps = {
  nftName?: string
  maxAmount?: string
  availableAmount?: string | number
  balance?: string
  sales?: number
}

export enum EMode {
  PROD = 'PROD',
  TEST = 'TEST'
}

export type IModifyModeForQuery<T> = T & {
  mode: EMode
}

export interface IIsAllowBuyNFTs {
  isCanBuySecondNft: boolean
  isCanBuyFoundingNft: boolean
}

export interface IUserNftSales {
  secondNftSales: number
  foundingNftSales: number
}

export interface ISendEmailStatus {
  message: string
}

export interface ISetHiddenUnhiddenUser {
  userId: number
  hidden: boolean
}

export interface BuyNFT {
  nftType: string // | ENftTypes,
  amount: number
  chainId: number // | 1(Mainnet) | 11155111(Sepolia),
}

export interface ICryptoResource {
  balance: string
  threshold: number
}
export interface INFTResource {
  balance: number
  threshold: number
}

export interface IResources {
  usdc?: ICryptoResource
  eth?: ICryptoResource
  foundingOwners?: INFTResource
  secondOwners?: INFTResource
}

enum ENftTypes {
  Founding = 'Founding',
  Second = 'Second'
}

export enum ENetworkTypes {
  ETH = 'ETH',
  SEPOLIA = 'SEPOLIA'
}

export enum EAirdropIssueType {
  Introductions = 'Introductions',
  Dividends = 'Dividends'
}

export interface AdminSendNft {
  nftType?: ENftTypes
  amount: number
  ethAddress: string
  networkType: ENetworkTypes
}

export interface ISellTransactions {
  country: ECountry
  offset: number
  page: number
}

export interface IUser {
  principal: string
  id: number
  tenant: string
  language: string
  role: UserRoles
  ethAddress: string
  isBuddy: boolean
  deactivated: boolean
  memberFrom: string
  hidden: boolean
  sales: number
  country: EIntroducerAddressTypes
  name?: string
  photoId?: number
  buddyId?: number
  photo?: string
}

export interface Fund {
  id: number
  name: string
  treasuryAddress: string
  airdropContract: string
  operatorId: number
  networkId: number
  countryId: number | null
  tokenId: number | null
  createdById: number | null
  createdAt: string | null
  updatedAt: string | null
  deletedAt: string | null
  investorCount?: number
  createdBy: User
}

export interface ResponseWithPagination<T> {
  items: T[]
  itemCount: number
  totalItems: number
  offset: number
  page: number
  totalPages: number
  nextPage?: number
  prevPage?: number
  totalInvestments?: number
}

export interface Investor {
  id: number
  isMotherTribe: boolean
  walletAddress: string
  name: string
  email: string | null
  whitelistStatus: WhiteListStatuses | null
  investment: number
  introducerId: number | null
  fundId: number
  hidden: boolean
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  investorFrom: string | null
  introducer: (Omit<User, 'ethAddress'> & { walletAddress: string }) | null
}

export interface Investment {
  id: number
  investorId: number
  investment: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  investor: Investor
}

export interface TeamMember {
  id: number
  userId: number
  fundId: number
  name: string | null
  role: UserRoles
  deactivated: boolean
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  user: IUser
  fund: Fund
}
